export const environment = {
  production: false,
  
    new:true  ,

      publicUrl: "http://app.him-eg.com",
     apiUrl: "https://app.him-eg.com/api",
    //  publicUrl: "https://him-eg.com/",
    //  apiUrl: "https://him-eg.com/api",
      // publicUrl: "http://127.0.0.1:8199/",
    //  apiUrl: "http://127.0.0.1:8199/api",



  backEndPublicUrl: "http://localhost:4000/",
  googleApiKey: "AIzaSyAtCTUfmq6JOFrE9Ib_HPEPFhUE9VdwcEs",
  frontEndPublicUrl: "http://127.0.0.1:4200/",
  business_name: "المعهد العالى لادارة HIM",
};


